import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'focus-sidebar',
  templateUrl: './focus-sidebar.component.html',
  styleUrls: ['./focus-sidebar.component.scss']
})
export class FocusSidebarComponent implements OnInit {
  @Input() appendTo = 'body';
  @Input() bodyColor = '#f3f6fb';
  @Input() btnSaveDisabled = false;
  @Input() btnSaveLabel = 'Save';
  @Input() btnSaveLadda: boolean;
  @Input() closeOnSave = true;
  @Input() dismissible = false;
  @Input() footerBoarder = true;
  @Input() footerColor = 'white';
  @Input() footerTemplate: TemplateRef<any>;
  @Input() header = null;
  @Input() headerBoarder = true;
  @Input() headerColor = 'white';
  @Input() headerTemplate: TemplateRef<any>;
  @Input() loading: boolean;
  @Input() modal = true;
  @Output() onClose = new EventEmitter<any>();
  @Output() onOpen = new EventEmitter<any>();
  @Output() onSave = new EventEmitter<any>();
  @Input() position = 'right';
  @Input() showBackIcon = false;
  @Input() showCloseIcon = false;
  @Input() showFooter = false;
  @Input() showHeader = true;
  @Input() size = 'md';
  @Input() styleClass = 'focus-sidebar';
  @Input() visible: boolean;
  @Output() visibleChange = new EventEmitter<boolean>();

  constructor() { }

  clickSave() {
    this.onSave.emit();
    this.closeOnSave && this.close('save');
  }

  close(reason?) {
    if (this.visible) {
      this.visible = false;
      this.visibleChange.emit(this.visible);
      this.onClose.emit(reason);
    }
  }

  ngOnInit() {
    if (this.size) {
    } this.styleClass = this.styleClass + ' focus-sidebar-' + this.size;
  }

  open() {
    this.visible = true;
    this.visibleChange.emit(this.visible);
    this.onOpen.emit();
    return this.onClose;
  }
}
